import uuid from 'uuid';

let initialMessages = [
  {
    author:'ai',
    text: "Hi there and welcome. This is Dr. Greene. I wish I could be with you in person, but I'd still love to help you today! So please ask me anything about ear infections, and I'll do my best to answer.",
    query: null,
  },
  {
    author:'ai',
    text: "This artificially intelligent bot has been programmed with my smarts and caring. It has a \"conversational interface\", meaning that you can either text it questions the way you might text them to me if you were asking for advice, or you can speak to it using your voice as if you were speaking to me in person. The AI will respond to you in my voice, but feel free to mute the volume anytime. Ok, let's get started! Here are some of the most popular questions I've received:",
    query: null,
  },
  {
    author:'ai',
    text: "Are all cases of ear infections the same?",
    query: null,
  },
  {
    author:'ai',
    text: "Are antibiotic eardrops safe?",
    query: null,
  },
  {
    author:'ai',
    text: "Are children who use pacifiers more likely to get ear infections?",
    query: null,
  },
];

export default {
  sound: true,
  playing: false,
  messages: initialMessages,
  uuid: uuid(),
  audioAmp: 0,
};



// WEBPACK FOOTER //
// ./src/data/initialState.js